<template>
  <div class="row">
    <div class="span8 detail-main">
      <el-page-header @back="$router.back()" content="活动详情" style="margin-bottom: 18px;"></el-page-header>
      <h3 style="font-size: 22px; margin-bottom: 16px;">{{ content.activity_title }}</h3>
      <div style="background: #f8f9fa; border-radius: 4px; padding: 16px 20px; margin-bottom: 20px;">
        <div class="info-unit"><span class="tagname">活动名称</span>{{ content.activity_title }}</div>
        <div class="info-unit"><span class="tagname">发起者</span><author-pop :author="content"></author-pop></div>
        <div class="info-unit"><span class="tagname">活动时间</span>{{ content.activity_statetime | dataFormat }} —— {{ content.activity_endtime | dataFormat }}</div>
        <div class="info-unit"><span class="tagname">活动人数</span>{{ content.activity_num }}</div>
        <div class="info-unit"><span class="tagname">活动地点</span>{{ content.activity_locale }}</div>
      </div>
      <h3 style="font-size: 18px; margin-bottom: 12px;">活动描述</h3>
      <blockquote class="post-body" v-html="content.activity_content" style="margin: 0 0 20px;"></blockquote>
      <div class="join-btn-wrap">
        <el-button type="primary" size="medium" @click="setjoin">参加</el-button>
      </div>
      <h3 style="font-size: 18px; margin-bottom: 12px;">活动公告</h3>
      <el-timeline v-if="announcementlist.length">
        <el-timeline-item v-for="item in announcementlist" :key="item.announcement_id" :timestamp="item.announcement_createtime | dataFormat">
          <el-card shadow="never">
            <p style="font-weight: bold;">{{ item.announcement_name }}</p>
            <p style="font-size: 13px; color: #666; margin-top: 6px;">{{ item.announcement_content }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <p v-else style="color: #999;">暂无公告</p>
      <div style="margin: 20px 0; text-align: center;">
        <el-button round disabled>👍 66</el-button>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <activity-widget />
    </div>
    <div class="span8">
      <comment-widget />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import carouselWidget from '@/components/carousel.vue'
import activityWidget from '@/components/activity.vue'
import commentWidget from '@/components/comment.vue'
import authorPop from '@/components/authorpop.vue'
import { getActivityContent, setJoin, getAnnouncementList } from '@/api'

export default {
  name: 'ActivityContent',
  components: { carouselWidget, activityWidget, commentWidget, authorPop },
  props: { id: { type: String, default: '' } },
  data() {
    return { content: {}, announcementlist: [] }
  },
  computed: {
    ...mapState({ commentnum: (s) => s.commentnum })
  },
  watch: {
    id: { immediate: true, handler() { this.getcontent() } }
  },
  methods: {
    getcontent() {
      if (!this.id) return
      getActivityContent(this.id).then((res) => {
        this.content = res.data || {}
        this.$store.dispatch('setcontentid', this.id)
        this.$store.dispatch('setcontentinfo', { name: this.content.activity_title, userid: this.content.user_id })
      })
      getAnnouncementList(this.id).then((res) => {
        this.announcementlist = res.data || []
      })
    },
    setjoin() {
      if (!localStorage.luffy_jwt_token) {
        this.$store.dispatch('user/close', true)
        return
      }
      setJoin({ type: this.$route.name, name: '', describe: '', content_id: this.id, contentname: this.content.activity_title, to_userid: this.content.user_id }).then((res) => {
        if (res.state.type === 'SUCCESS') this.$message.success('参加成功')
        else this.$message.error(res.state.msg || '你已经报名参加了本项目')
      })
    }
  }
}
</script>
